// extracted by mini-css-extract-plugin
export default {"footer-container":"Footer_footer-container__1njCN","footer-parent":"Footer_footer-parent__Ri1Im"};